export default __webpack_public_path__ + "static/media/love.12a18842.svg";